var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgOpera = function SvgOpera(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#opera_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#opera_svg__b)",
    d: "M5.369 12.506C4.48 11.463 3.913 9.92 3.875 8.187v-.374c.038-1.732.612-3.276 1.494-4.32 1.15-1.487 2.837-2.155 4.744-2.155 1.175 0 2.28.08 3.218.706A7.916 7.916 0 0 0 8.031 0H8a8 8 0 0 0-8 8 8.004 8.004 0 0 0 7.619 7.994C7.744 16 7.875 16 8 16c2.05 0 3.919-.769 5.331-2.037-.937.625-1.981.65-3.156.65-1.9.006-3.663-.613-4.806-2.107Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#opera_svg__c)",
    d: "M5.369 3.494C6.1 2.625 7.05 2.106 8.087 2.106c2.332 0 4.22 2.638 4.22 5.9 0 3.263-1.888 5.9-4.22 5.9-1.037 0-1.98-.525-2.718-1.387 1.15 1.487 2.856 2.437 4.756 2.437a5.757 5.757 0 0 0 3.206-.981A8.023 8.023 0 0 0 16 8c0-2.369-1.031-4.5-2.669-5.963a5.742 5.742 0 0 0-3.206-.98c-1.906 0-3.613.943-4.756 2.437Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "opera_svg__b",
    x1: 6.666,
    x2: 6.666,
    y1: 0.261,
    y2: 15.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#FA1A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#ED1528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#D60E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#B70519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "opera_svg__c",
    x1: 10.683,
    x2: 10.683,
    y1: 1.175,
    y2: 14.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF4B4B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "opera_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOpera);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;